import { useMutation } from '@tanstack/react-query';

import { PricingPlanObjectFormSchemaValues } from 'src/features/pricing/sites/utils/formSchema';
import { ZonePricingPlan } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/zone-pricing-plan/:planId/`;
type MutationFnType = typeof mutationFn;

interface DTO {
    data: PricingPlanObjectFormSchemaValues;
    planId: string;
    parkingId: string;
}
const mutationFn = ({ planId, parkingId, data }: DTO): Promise<ZonePricingPlan> => {
    return axios.put(formatResourcePath(RESOURCE, { planId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateZonePricingPlan };
